import api from "../apiConfig";
import paramsFactory from "../../utils/paramsFactory";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/transfer-request?${p}`);
  },
  showById(id) {
    return api.get(`/api/v1/transfer-request/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/transfer-request`, data);
  },
  accept(id) {
    return api.post(`/api/v1/transfer-request/${id}/accept`, {});
  },
  reject(id, data) {
    return api.post(`/api/v1/transfer-request/${id}/reject`, data);
  },
};
